import { Component, inject } from '@angular/core';
import { ItemActionResult, NotificationService } from '@ntap/core';
import { PrimeNGButtonSaveCloseItemActionComponent } from '@ntap/primeng';
import { Observable, tap } from 'rxjs';
@Component({
  selector: 'app-save-mjesto',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class ActionSaveMjestoComponent extends PrimeNGButtonSaveCloseItemActionComponent {
  private notifService = inject(NotificationService);

  protected override doExecuteWithItem(
    item: any
  ): Observable<ItemActionResult> {
    let condition = false;
    if (item.$childItemsToSave) {
      const tempArray = item.$childItemsToSave.filter(
        (child: { viewData: any }) =>
          child.viewData['sv~naziv~vrsta_naziva'] !== null &&
          child.viewData['sv~naziv~vrijednost_naziva'] !== null
      );
      if (tempArray.length < item.$childItemsToSave.length) {
        condition = true;
        item.$childItemsToSave = tempArray;
      }
    }
    return super.doExecuteWithItem(item).pipe(
      tap(() => {
        if (condition)
          this.notifService.error('Neuspješno spremanje dodatnog naziva');
      })
    );
  }
}
